export default __webpack_public_path__ + "static/media/sell_background.438d7ea3.jpg";